const SelectedColor = class extends HTMLElement {
  connectedCallback() {
    this.optionsWrapper = this.closest(".meta-variant-picker");
    this.optionsWrapper.addEventListener(
      "change",
      this.handleColorChange.bind(this),
    );
    this.handleColorChange();
  }
  handleColorChange() {
    setTimeout(() => {
      const selectedOption = this.optionsWrapper.querySelector("input:checked");
      if (!selectedOption) return;
      this.innerHTML = selectedOption.value;
    }, 100);
  }
};

window.customElements.define("selected-color", SelectedColor);

function mountRadioMirror(sourceSel, targetSel) {
  const src = document.querySelector(sourceSel);
  const mount = document.querySelector(targetSel);
  if (!src || !mount) return;

  const originals = [...src.querySelectorAll('input[type="radio"]')];
  const originalName = originals[0]?.name;
  const dupName = originalName + "__dup";
  const suffix = "--dup-" + Math.random().toString(36).slice(2, 8);

  // Clone and make it a separate radio group with fixed label "for"
  const clone = src.cloneNode(true);
  clone.querySelectorAll('input[type="radio"]').forEach((dup, i) => {
    const oldId = dup.id;
    const newId = (oldId || originalName) + suffix + "-" + i;
    dup.id = newId;
    dup.name = dupName; // separate group for UI/styling
    dup.dataset.value = originals[i]?.value ?? dup.value; // map by value
    clone
      .querySelectorAll(`label[for="${oldId}"]`)
      .forEach((l) => (l.htmlFor = newId));
  });

  // Initialize the duplicate to match whatever is checked in originals
  const checkedVal = originals.find((r) => r.checked)?.value;
  clone
    .querySelectorAll(`input[type="radio"][name="${dupName}"]`)
    .forEach((r) => (r.checked = r.dataset.value === checkedVal));

  clone.classList.remove("hidden");

  mount.replaceChildren(clone);

  // ONE-WAY: when duplicate changes, set the matching original
  clone.addEventListener("change", (e) => {
    const t = e.target;
    if (!t.matches(`input[type="radio"][name="${dupName}"]`)) return;
    const val = t.dataset.value;
    const match = src.querySelector(
      `input[type="radio"][name="${originalName}"][value="${CSS.escape(val)}"]`,
    );
    if (match) {
      match.checked = true;
      // fire events in case other code listens to originals
      match.dispatchEvent(new Event("input", { bubbles: true }));
      match.dispatchEvent(new Event("change", { bubbles: true }));
    }
  });

  src.classList.add("hidden");
}

(function () {
  const personalizeYes = document.getElementById("personalize-product");
  const personalizeNo = document.getElementById("dont-personalize-product");
  const optionMain = document.querySelector(".selector_option-main");
  const lineItemField = document.getElementById("your-name");
  const embroideryRadios = document.querySelectorAll(".embroidery-color-radio");

  function toggleOptionMain() {
    if (!personalizeYes) return;
    if (personalizeYes.checked) {
      optionMain.classList.add("active");
      optionMain.style.display = "block";
      if (lineItemField) {
        lineItemField.setAttribute("required", "required");
      }
      if (embroideryRadios.length > 0) {
        document
          .querySelectorAll(".embroidery-color-radio:first-of-type")
          .forEach((i) => (i.checked = true));
        // embroideryRadios[0].checked = true;
      }

      document
        .querySelectorAll(".selector_option-main selected-color")
        .forEach((itm) => itm.handleColorChange());
    } else if (personalizeNo.checked) {
      optionMain.classList.remove("active");
      optionMain.style.display = "none";
      if (lineItemField) {
        lineItemField.removeAttribute("required");
        lineItemField.value = "";
      }
      embroideryRadios.forEach((radio) => (radio.checked = false));
    }
  }

  toggleOptionMain();

  personalizeYes.addEventListener("change", toggleOptionMain);
  personalizeNo.addEventListener("change", toggleOptionMain);

  mountRadioMirror('[data-option="Embroidery style"]', "#EmbroideryStyle");
  // mountRadioMirror('#ship-src', '#ship-dup');
})();
// document.addEventListener("DOMContentLoaded", );

(function () {
  const personalizationText = document.querySelector(
    "#your-name[name='properties[Text]']",
  );

  const personalizationLimit = document.querySelector(
    "[data-personalization-text-limit]",
  );

  const personalizationLimitLength = document.querySelector(
    "[data-personalization-text-length]",
  );

  const personalizationTextLimitContainer = document.querySelector(
    ".personalization-text__limit-container",
  );

  if (!personalizationTextLimitContainer) return;

  personalizationText.addEventListener(
    "keyup",
    (event) =>
      (personalizationLimitLength.innerHTML = event.target.value.length),
  );

  document.addEventListener("on:variant:change", (event) => {
    const selectedOptions = event.detail.selectedOptions;

    personalizationTextLimitContainer.classList.remove("hidden");

    if (selectedOptions.find((itm) => itm == "Bold 2 letters")) {
      personalizationText.setAttribute("maxlength", 2);
      personalizationText.style.setProperty("--font-family", "Arial");
      personalizationText.style.setProperty("--font-weight", "bold");
      personalizationText.style.setProperty("--text-transform", "uppercase");
      personalizationText.value.length > 2 &&
        (personalizationText.value = personalizationText.value.slice(0, 2));

      personalizationLimitLength.innerHTML = personalizationText.value.length;
      personalizationLimit.innerHTML = 2;

      return;
    }

    if (selectedOptions.find((itm) => itm == "Bold 3 letters")) {
      personalizationText.setAttribute("maxlength", 3);
      personalizationText.style.setProperty("--font-family", "Arial");
      personalizationText.style.setProperty("--font-weight", "bold");
      personalizationText.style.setProperty("--text-transform", "uppercase");

      personalizationText.value.length > 3 &&
        (personalizationText.value = personalizationText.value.slice(0, 3));

      personalizationLimitLength.innerHTML = personalizationText.value.length;
      personalizationLimit.innerHTML = 3;
      return;
    }

    personalizationText.style.setProperty("--font-family", "Madre Script");
    personalizationText.style.setProperty("--font-weight", "normal");
    personalizationText.style.setProperty("--text-transform", "capitalize");

    personalizationText.removeAttribute("maxlength");
    personalizationTextLimitContainer.classList.add("hidden");
  });
})();
